export enum CtaTypes {
  CANCEL = 'CANCEL',
  RESUME_CLAIM = 'RESUME_CLAIM',
  REPORT_NEW_CLAIM = 'REPORT_NEW_CLAIM'
}
